import type { FC } from "preact/compat";
import { Navigate } from "react-router-dom";
import { me, useApp } from "~/core/store";
import { useBreakpoint } from "~/hooks";
import { MOBILE_WIDGETS_KEY } from "~/routes/dashboard/Mobile/preset";
import { APP_VISITS_KEY } from "../Main/Visits";

const INSTALLATION_REGEX = /\/me\/(\w+)\/\w+\//;

const getRedirect = (md: boolean, dashboardStartup: boolean) => {
    if (md) {
        return null;
    }

    try {
        const visits: [string, string][] =
            JSON.parse(localStorage.getItem(APP_VISITS_KEY) ?? "{}").last ?? [];
        const widgets: unknown[] =
            JSON.parse(localStorage.getItem(MOBILE_WIDGETS_KEY) ?? "[]") ?? [];

        if (visits.length === 0 || (widgets.length !== 0 && dashboardStartup)) {
            return null;
        }

        const [path] = visits[0];
        const match = path.match(INSTALLATION_REGEX);

        if (!match) {
            return null;
        }

        return [path, match[1]] as const;
    } catch {
        return null;
    }
};

const Redirect: FC = () => {
    const {
        api: { connection, installation },
        settings: { dashboardStartup },
    } = useApp();
    const bpMd = useBreakpoint("md");
    const redirect = getRedirect(bpMd.peek(), dashboardStartup.value);

    if (!connection.value) {
        const finalTo = redirect
            ? `/p/login?continue=${encodeURIComponent(redirect[0])}&installation=${redirect[1]}`
            : "/p/login";

        return <Navigate replace to={finalTo} />;
    }

    const finalTo =
        redirect && redirect[1] === installation.peek()
            ? redirect[0]
            : me("dashboard");

    return <Navigate replace to={finalTo} />;
};

export default Redirect;
